import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { ModuleMenu, INSTRUCTION, GM_APP } from 'src/app/models/common';
import { Subject } from 'rxjs';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
///import * as $ from 'jquery';
import { HeadService } from 'src/app/services/common/headservice';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';

@Component({
  selector: 'app-user-instruction-modal',
  templateUrl: './user-instruction-modal.component.html',
  styleUrls: ['./user-instruction-modal.component.scss']
})
export class UserInstructionModalComponent implements OnInit {
  @Input() public Content: any;
  id: number;
  data: any;
  instruction: INSTRUCTION;
  title: string;
  description: string;
  action: Subject<any> = new Subject();
  transid: string;
  isAck = false;
  menudata: ModuleMenu;
  screentoopen: string;
  grantsapp: GM_APP;
  ApplicationType:string;
  constructor(
    private modalService: NgbModal,
    public modalRef: NgbActiveModal,
    private router: Router,
    private commonService: CommonService,
    private appFunctions: AppFunctionsService,
    private summaryService: GrantsSummaryService,
    private header: HeadService,
    private grantsDataShare: GrantsDatashareService
  ) { }

  ngOnInit() {
    this.getGrantsInstructions();
  }

  add() {
    if (this.isAck) {
      this.modalRef.dismiss();
      var rtype = this.Content.rtype;
      this.commonService.appId = "";
      this.commonService.setGrantsApp(null);
      this.menudata = new ModuleMenu();
      let modulecode = "";
      if (rtype === 1)
      {
        modulecode = "GRANTSCME";
        this.grantsDataShare.setCMEID("");
      }
      else if (rtype === 2)
      {
        modulecode = "GRANTSSPONSORSHIP";
        this.grantsDataShare.setSPONSORSHIPID("");

      }
      else if (rtype === 3)
      {
        modulecode = "GRANTSCHARITABLE";
        this.grantsDataShare.setCharityID("");
      }
      this.commonService.removeLeftMenu();
      this.menudata.module = modulecode;
      this.menudata.operation = "New";
      this.menudata.appId = "";
      this.menudata.formstate = "Draft";
      this.commonService.setModluleMenu(this.menudata);
      this.header.setHeader(this.menudata);
      this.grantsDataShare.setGrantApplicationID("");
      this.summaryService.getGrantSearchSummary("api/common/getgrantsappmain/" + rtype, null).subscribe(data => {
        this.router.navigate(['/home/grants/my-applications/application-ext/:0/' + data.StartMenu], { skipLocationChange: true, queryParams: { module: "grants",submodule:modulecode, id: 0, app_ext: true, screen_type: "my-applications",ApplicationType:this.ApplicationType } })

      });
    }
    else {
      this.commonService.ValidationBanner( 'Please Acknowledge the Compliance Statement by marking the checkbox against "I Acknowledged that the failure to comply with these terms and conditions".' )
    }
  }

  getGrantsInstructions() {
    let instructionid = "6"
    if (this.Content.rtype === 1)
      instructionid = "6";
    else if (this.Content.rtype === 2)
      instructionid = "10";
    else if (this.Content.rtype === 3)
      instructionid = "8";
    
    this.summaryService.getInstruction(instructionid).subscribe(summary => {
      this.instruction = summary;
      if (this.instruction != null) {
        this.title = this.instruction.NAME;
        this.description = this.instruction.DESCRIPTION;
      }

    });
  }

}
